import React, { useEffect, useState } from "react";
import { useLanguageContext } from "../../Context/LanguageContext";
import CostCenterGroupAction from "../../Actions/CostCenterGroupAction";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import commonUtils from "../../helpers/commonUtils";

const AddCostCenterGroup = (props) => {
  const { costCentergrpDetails, closeAddEditCostCenterGrpPopUpCallback } = {
    ...props,
  };
  const { localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [costCenterGrp, setCostCenterGrp] = useState("");
  const [costCenterGrpId, setCostCenterGrpId] = useState(0);

  const CostCenterGrp = (e) => {
    e.preventDefault();
    const CostCentergrpData = costCenterGrpId
      ? {
          ID: costCenterGrpId,
          CostGroup: costCenterGrp.trim(),
        }
      : { CostGroup: costCenterGrp.trim() };
    setGlobalSpinner(true);
    CostCenterGroupAction.saveUpdateCostCenterGrp(CostCentergrpData);
  };

  useEffect(() => {
    if (costCentergrpDetails !== "") {
      setCostCenterGrp(costCentergrpDetails.costGroup);
      setCostCenterGrpId(costCentergrpDetails.id);
      commonUtils.setIsEdit(true);
    } else {
      commonUtils.setIsEdit(false);
    }
  }, [costCentergrpDetails]);

  function handleClosePopOver() {
    setCostCenterGrp("");
    setCostCenterGrpId(0);
    closeAddEditCostCenterGrpPopUpCallback();
  }
  return (
    <div
      className="modal fade"
      id="addCostCenterGrp"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="addCostCenterGrp"
      aria-hidden="true"
      data-backdrop="static"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="addCostCenterGrpHeading">
              {costCentergrpDetails === ""
                ? localization.addCostCenterGrp
                : localization.editCostCenterGrp}
            </h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              id="addCostCenterGroupModalClose"
              onClick={handleClosePopOver}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <form
            id="createCostCenterGrpForm"
            name="createCostCenterGrpFormm"
            onSubmit={CostCenterGrp}
          >
            <div className="modal-body">
              <div className="row">
                <div className="col">
                  <div className="form-group">
                    <label htmlFor="costCenterGrp">
                      {localization.costCenterGrpName}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="costCenterGrp"
                      name="costCenterGrp"
                      placeholder={localization.costCenterGrpName}
                      required
                      value={costCenterGrp}
                      onChange={(e) => {
                        e.preventDefault();
                        if (costCenterGrp !== "") {
                          setCostCenterGrp(e.target.value);
                        } else {
                          setCostCenterGrp(e.target.value.trim());
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="form-group marProp">
                <button
                  type="submit"
                  className="btn btn-primary btn-block mb-4"
                  disabled={costCenterGrp.length > 0 ? false : true}
                >
                  {localization.save}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddCostCenterGroup;
